module.exports = __webpack_public_path__ + "img/info_2recruit.003965d8.png";